

import { useApiFetch } from '@/helper/apiFetch';
import { useEffect, useState } from 'react';
import { useTranslate } from "@/helper/translate";
import { blobToDataURL } from '@/helper/sort';
type TemplateProps = {
  format?: string;
  customerId?: string;
  onClose: (templateId: string | null) => void;
};


export function Templates({  customerId, onClose }: TemplateProps) {

  const apiFetch = useApiFetch();
  const { translate } = useTranslate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [templates, setTemplates] = useState<{ templateId: string, templateName: string, snapshot: string, url : string }[]>([]);



  useEffect(() => {



//always load template as 16x9
    apiFetch(`/App/GetTemplates?customerId=${customerId}&format=16x9`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {
        setTemplates(data);
        setIsLoaded(true);
      })
      .catch(err => {
        console.error(err);

      });
  }, []);

    useEffect(() => {
      const pending = templates.filter(t => !t.url && t.snapshot);
      pending.forEach(async (t) => {
        try {
          const res = await apiFetch(`/App/ServeImage?path=${encodeURIComponent(t.snapshot)}`);
          if (!res.ok) throw new Error("Failed to fetch image");
          const url = await blobToDataURL(await res.blob());

          setTemplates(prev =>
            prev.map(p => p.templateId === t.templateId ? { ...p, url } : p)
          );
        } catch (e) {
          console.error(e);
        }
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templates.length]); // run when initial list arrives/changes


  return (

    <div className="popCnt p-0">
      {!isLoaded ? (
        <div className="w-full text-center my-10">{translate("common.loading")}</div>
      ) : (


        <div>
          <div className="content-body flex gap-4 flex-wrap max-h-[80vh] overflow-y-auto -mr-8 overflow-x pb-4">
            {
            templates.length == 0 ? <div> {translate("ui.noTemplates")}</div> : (
            templates.map((item, index) => (


              <div key={item.templateId} className={"relative"}>

                <div className="w-[250px] pt-3 pb-3 px-2 bg-white border rounded-md shadow-lg shadow-gray-300 cursor-pointer hover:border-sky-600 hover:shadow-sky-200" onClick={() => onClose(item.templateId as string)}>

                  <div className="info pb-2">
                    <h3 className="description font-bold">{item.templateName}</h3>
                  </div>
                  <div className=" h-[120px] flex justify-center">
                    <img src={item.url}  />
                  </div>

                </div>

              </div>)))}
          </div>

        </div>
      )}


    </div>

  )
}



